import { render } from "./CustomChartDoughnut.vue?vue&type=template&id=8f915d5e&scoped=true"
import script from "./CustomChartDoughnut.vue?vue&type=script&lang=js"
export * from "./CustomChartDoughnut.vue?vue&type=script&lang=js"

import "./CustomChartDoughnut.vue?vue&type=style&index=0&id=8f915d5e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f915d5e"]])

export default __exports__